import { render, staticRenderFns } from "./PortraitHeader.vue?vue&type=template&id=89dcb260"
import script from "./PortraitHeader.vue?vue&type=script&lang=js"
export * from "./PortraitHeader.vue?vue&type=script&lang=js"
import style0 from "./PortraitHeader.vue?vue&type=style&index=0&id=89dcb260&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports